import { useAppContext } from "../../../AppContext";
import { DefaultButton } from "../button/defaultButton/DefaultButton";
import styles from "./ErrorPage.module.scss";

interface ISpecificPageNotFoundProps {
  text: string;
  buttonText: string;
  onButtonClick: () => void;
}

export const SpecificPageNotFound = ({
  text,
  buttonText,
  onButtonClick,
}: ISpecificPageNotFoundProps) => {
  const { isDesktopOrTablet } = useAppContext();

  return (
    <div className={styles.root}>
      <p>{text}</p>
      <DefaultButton
        className={styles.root_button}
        label={buttonText}
        onClick={onButtonClick}
        width={isDesktopOrTablet ? "400px" : "90%"}
      />
    </div>
  );
};
